export const VALUATION_MARKET_DATE_TEST_IDS = {
  dateInput: 'valuation-market-date__date-input',
  dialog: 'valuation-market-date__dialog',
  display: 'valuation-market-date__display',
  editMarketDateMenuItem: 'valuation-market-date__edit-market-date',
  saveButton: 'valuation-market-date__save-button',
  versionSelector: 'valuation-market-date__version-selector',
} as const;
